// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================= */
/*      mobile.css (FULL)        */
/* ============================= */

/* Container tổng */
.mobile-calendar-container {
  padding: 0;
  background: #1e1e1e;
  color: #fff;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Thanh header tháng/ngày */
.mobile-month-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #121212;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #333;
}
.mobile-month-header .title {
  color: #fff;
  font-size: 1.125rem;
  font-weight: 600;
}
.mobile-month-header button {
  background: transparent;
  border: none;
  color: #2979ff;
  font-size: 1.5rem;
  width: 2.5rem;
  height: 2.5rem;
  cursor: pointer;
}

/* Filter phòng */
.mobile-room-select {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  background: #121212;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #333;
}
.mobile-room-select label {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
  white-space: nowrap;
  font-size: 0.75rem;
  color: #fff;
}
.mobile-room-select input {
  display: none;
}
.mobile-room-select span {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 2px solid;
  display: inline-block;
}

/* Wrapper để bật scroll cho calendar */
.mobile-calendar-content {
  flex: 1;
  min-height: 0;
  width: 100%;               /* thêm để lấp đầy ngang */
  /* overflow-y: auto; */
  overflow-x: auto;          /* hoặc !important nếu cần */
  -webkit-overflow-scrolling: touch;
}

/* ===== FullCalendar overrides chung ===== */
.mobile-calendar-content .fc {
  background: #1e1e1e !important;
  color: #eee !important;
}

/* ===== Chỉ trên mobile (≤767px) ===== */
@media (max-width: 767px) {

  /* Ẩn toolbar mặc định */
  .mobile-calendar-content .fc-header-toolbar {
    display: none !important;
  }

  /* Style hàng header (ngày & all-day label) */
  .mobile-calendar-content .fc .fc-col-header-cell,
  .mobile-calendar-content .fc .fc-scrollgrid-section-header th {
    background: #121212 !important;
    border-color: #333 !important;
    color: #ccc !important;
  }

  /* —— Remove separator giữa header và all-day slot —— */
  .mobile-calendar-content .fc .fc-scrollgrid-section-header {
    border-bottom: none !important;
  }
  .mobile-calendar-content .fc .fc-scrollgrid-section-header th {
    border-bottom: none !important;
  }
  .mobile-calendar-content .fc .fc-scrollgrid-section-body:first-of-type {
    border-top: none !important;
  }
  .mobile-calendar-content .fc .fc-timegrid-all-day-cushion {
    border-bottom: none !important;
  }

  /* Resize height của từng row xuống 2.5rem */
  .mobile-calendar-content .fc .fc-scrollgrid-section-body tr {
    height: 3rem !important;
  }

  /* Resize slot height xuống 2.5rem */
  .mobile-calendar-content .fc .fc-timegrid-slot {
    height: 3rem !important;
    min-height: 3rem !important;
    border-bottom: 3px solid #333 !important;
  }

  /* Thay đổi font và màu cho trục giờ */
  .mobile-calendar-content .fc .fc-timegrid-axis-cushion {
    color: #888 !important;
    font-size: 0.75rem !important;
  }
  .mobile-calendar-content .fc-event {
    position: absolute !important;
    height: auto !important;
  }

  /* Đường chỉ báo “giờ hiện tại” */
  .mobile-calendar-content .fc .fc-timegrid-now-indicator {
    border-top: 2px solid #2979ff !important;
  }

  /* Style cho sự kiện */
  .mobile-calendar-content .fc-event {
    border-radius: 4px !important;
    padding: 0.2rem 0.5rem !important;
    font-size: 0.85rem !important;
    max-width: 100% !important;  
    white-space: normal !important;
  }
  .mobile-calendar-content .fc-event .fc-event-title {
    white-space: normal !important;
  }

  /* Đẩy vùng events sang phải, không chèn vào cột giờ */
  .mobile-calendar-content .fc .fc-timegrid-col-events {
    /* margin-left: 1rem !important; */
    width: 100% !important;
    box-sizing: border-box !important;
  }

  /* Ẩn các nút view không dùng */
  .mobile-calendar-content .fc .fc-listWeek-button,
  .mobile-calendar-content .fc .fc-dayGridMonth-button {
    display: none !important;
  }

  /* Loại bỏ padding thừa */
  .mobile-calendar-content .fc-scroller-harness {
    padding: 0 !important;
  }
  /* ─── Remove “today” highlight on mobile ─── */
.mobile-calendar-content .fc .fc-col-header-cell.fc-day-today,
.mobile-calendar-content .fc .fc-timegrid-col.fc-day-today,
.mobile-calendar-content .fc .fc-scrollgrid-section-body td.fc-day.fc-day-today,
.mobile-calendar-content .fc .fc-scrollgrid-section-body:first-of-type tbody > tr:first-child td.fc-day-today {
  background-color: transparent !important;
}
/* 3) Cho cột giờ (axis) fixed width */
.mobile-calendar-content .fc .fc-timegrid-axis {
  width: 3rem !important; /* có thể điều chỉnh 2.5rem / 4rem tùy font-size */
  min-width: 3rem !important;
  max-width: 3rem !important;
}

/* 4) Bỏ margin-left cũ nếu có */
.mobile-calendar-content .fc .fc-timegrid-col-events {
  margin-left: 0 !important;
}

/* 5) Ép phần event vừa khít phần còn lại của table */
.mobile-calendar-content .fc .fc-timegrid-col-events {
  width: calc(100% - 1rem) !important;
  box-sizing: border-box !important;
}.recurrence-form .weekdays-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0.5rem 0;
}

.recurrence-form .weekdays-row .day {
  padding: 0.4rem 0.6rem;
  border-radius: 4px;
  background: #2e2e2e;
  color: #ccc;
  border: 1px solid #444;
  cursor: pointer;
}

.recurrence-form .weekdays-row .day.active {
  background: #2979ff;
  color: #fff;
  border-color: #2979ff;
}
.mobile-month-header .today-button {
  font-size: 0.75rem;
  /* padding: 0.25rem 0.5rem; */
  /* margin-left: 0.5rem; */
}
.mobile-calendar-content .fc tr.fc-scrollgrid-section-header.fc-scrollgrid-section-sticky > th {
  background: #121212 !important;         /* nền trùng với mobile header */
  position: sticky !important;
  /* top = chiều cao .mobile-month-header + .mobile-room-select */
  top: calc( (3rem) + (2.5rem) ) !important; 
  z-index: 49 !important;
  height: 3rem !important;                /* bằng row slot height */
}

/* ─── Center the day labels vertically ─── */
.mobile-calendar-content .fc .fc-col-header-cell-cushion {
  display: flex !important;
  flex-direction: column-reverse !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
}
.mobile-calendar-container .ui-checkbox__label {
  color: #ffffff !important;
}


}
`, "",{"version":3,"sources":["webpack://./src/client/setaTab/mobile.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;;AAElC,mBAAmB;AACnB;EACE,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,OAAO;EACP,aAAa;EACb,WAAW,gBAAgB,0BAA0B;EACrD,sBAAsB;EACtB,gBAAgB,WAAW,4BAA4B;EACvD,iCAAiC;AACnC;;AAEA,6CAA6C;AAC7C;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;;EAEE,wBAAwB;EACxB;IACE,wBAAwB;EAC1B;;EAEA,6CAA6C;EAC7C;;IAEE,8BAA8B;IAC9B,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA,uDAAuD;EACvD;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;;EAEA,4CAA4C;EAC5C;IACE,uBAAuB;EACzB;;EAEA,oCAAoC;EACpC;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,wCAAwC;EAC1C;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;EACA;IACE,6BAA6B;IAC7B,uBAAuB;EACzB;;EAEA,iCAAiC;EACjC;IACE,wCAAwC;EAC1C;;EAEA,sBAAsB;EACtB;IACE,6BAA6B;IAC7B,iCAAiC;IACjC,6BAA6B;IAC7B,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;;EAEA,sDAAsD;EACtD;IACE,kCAAkC;IAClC,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA,+BAA+B;EAC/B;;IAEE,wBAAwB;EAC1B;;EAEA,yBAAyB;EACzB;IACE,qBAAqB;EACvB;EACA,+CAA+C;AACjD;;;;EAIE,wCAAwC;AAC1C;AACA,sCAAsC;AACtC;EACE,sBAAsB,EAAE,kDAAkD;EAC1E,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B;;AAEA,qDAAqD;AACrD;EACE,mCAAmC;EACnC,iCAAiC;AACnC,CAAC;EACC,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,8BAA8B,UAAU,gCAAgC;EACxE,2BAA2B;EAC3B,+DAA+D;EAC/D,yCAAyC;EACzC,sBAAsB;EACtB,uBAAuB,iBAAiB,yBAAyB;AACnE;;AAEA,6CAA6C;AAC7C;EACE,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;;AAGA","sourcesContent":["/* ============================= */\n/*      mobile.css (FULL)        */\n/* ============================= */\n\n/* Container tổng */\n.mobile-calendar-container {\n  padding: 0;\n  background: #1e1e1e;\n  color: #fff;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Thanh header tháng/ngày */\n.mobile-month-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #121212;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #333;\n}\n.mobile-month-header .title {\n  color: #fff;\n  font-size: 1.125rem;\n  font-weight: 600;\n}\n.mobile-month-header button {\n  background: transparent;\n  border: none;\n  color: #2979ff;\n  font-size: 1.5rem;\n  width: 2.5rem;\n  height: 2.5rem;\n  cursor: pointer;\n}\n\n/* Filter phòng */\n.mobile-room-select {\n  display: flex;\n  gap: 0.5rem;\n  overflow-x: auto;\n  background: #121212;\n  padding: 0.5rem 1rem;\n  border-bottom: 1px solid #333;\n}\n.mobile-room-select label {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  cursor: pointer;\n  white-space: nowrap;\n  font-size: 0.75rem;\n  color: #fff;\n}\n.mobile-room-select input {\n  display: none;\n}\n.mobile-room-select span {\n  width: 1rem;\n  height: 1rem;\n  border-radius: 50%;\n  border: 2px solid;\n  display: inline-block;\n}\n\n/* Wrapper để bật scroll cho calendar */\n.mobile-calendar-content {\n  flex: 1;\n  min-height: 0;\n  width: 100%;               /* thêm để lấp đầy ngang */\n  /* overflow-y: auto; */\n  overflow-x: auto;          /* hoặc !important nếu cần */\n  -webkit-overflow-scrolling: touch;\n}\n\n/* ===== FullCalendar overrides chung ===== */\n.mobile-calendar-content .fc {\n  background: #1e1e1e !important;\n  color: #eee !important;\n}\n\n/* ===== Chỉ trên mobile (≤767px) ===== */\n@media (max-width: 767px) {\n\n  /* Ẩn toolbar mặc định */\n  .mobile-calendar-content .fc-header-toolbar {\n    display: none !important;\n  }\n\n  /* Style hàng header (ngày & all-day label) */\n  .mobile-calendar-content .fc .fc-col-header-cell,\n  .mobile-calendar-content .fc .fc-scrollgrid-section-header th {\n    background: #121212 !important;\n    border-color: #333 !important;\n    color: #ccc !important;\n  }\n\n  /* —— Remove separator giữa header và all-day slot —— */\n  .mobile-calendar-content .fc .fc-scrollgrid-section-header {\n    border-bottom: none !important;\n  }\n  .mobile-calendar-content .fc .fc-scrollgrid-section-header th {\n    border-bottom: none !important;\n  }\n  .mobile-calendar-content .fc .fc-scrollgrid-section-body:first-of-type {\n    border-top: none !important;\n  }\n  .mobile-calendar-content .fc .fc-timegrid-all-day-cushion {\n    border-bottom: none !important;\n  }\n\n  /* Resize height của từng row xuống 2.5rem */\n  .mobile-calendar-content .fc .fc-scrollgrid-section-body tr {\n    height: 3rem !important;\n  }\n\n  /* Resize slot height xuống 2.5rem */\n  .mobile-calendar-content .fc .fc-timegrid-slot {\n    height: 3rem !important;\n    min-height: 3rem !important;\n    border-bottom: 3px solid #333 !important;\n  }\n\n  /* Thay đổi font và màu cho trục giờ */\n  .mobile-calendar-content .fc .fc-timegrid-axis-cushion {\n    color: #888 !important;\n    font-size: 0.75rem !important;\n  }\n  .mobile-calendar-content .fc-event {\n    position: absolute !important;\n    height: auto !important;\n  }\n\n  /* Đường chỉ báo “giờ hiện tại” */\n  .mobile-calendar-content .fc .fc-timegrid-now-indicator {\n    border-top: 2px solid #2979ff !important;\n  }\n\n  /* Style cho sự kiện */\n  .mobile-calendar-content .fc-event {\n    border-radius: 4px !important;\n    padding: 0.2rem 0.5rem !important;\n    font-size: 0.85rem !important;\n    max-width: 100% !important;  \n    white-space: normal !important;\n  }\n  .mobile-calendar-content .fc-event .fc-event-title {\n    white-space: normal !important;\n  }\n\n  /* Đẩy vùng events sang phải, không chèn vào cột giờ */\n  .mobile-calendar-content .fc .fc-timegrid-col-events {\n    /* margin-left: 1rem !important; */\n    width: 100% !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Ẩn các nút view không dùng */\n  .mobile-calendar-content .fc .fc-listWeek-button,\n  .mobile-calendar-content .fc .fc-dayGridMonth-button {\n    display: none !important;\n  }\n\n  /* Loại bỏ padding thừa */\n  .mobile-calendar-content .fc-scroller-harness {\n    padding: 0 !important;\n  }\n  /* ─── Remove “today” highlight on mobile ─── */\n.mobile-calendar-content .fc .fc-col-header-cell.fc-day-today,\n.mobile-calendar-content .fc .fc-timegrid-col.fc-day-today,\n.mobile-calendar-content .fc .fc-scrollgrid-section-body td.fc-day.fc-day-today,\n.mobile-calendar-content .fc .fc-scrollgrid-section-body:first-of-type tbody > tr:first-child td.fc-day-today {\n  background-color: transparent !important;\n}\n/* 3) Cho cột giờ (axis) fixed width */\n.mobile-calendar-content .fc .fc-timegrid-axis {\n  width: 3rem !important; /* có thể điều chỉnh 2.5rem / 4rem tùy font-size */\n  min-width: 3rem !important;\n  max-width: 3rem !important;\n}\n\n/* 4) Bỏ margin-left cũ nếu có */\n.mobile-calendar-content .fc .fc-timegrid-col-events {\n  margin-left: 0 !important;\n}\n\n/* 5) Ép phần event vừa khít phần còn lại của table */\n.mobile-calendar-content .fc .fc-timegrid-col-events {\n  width: calc(100% - 1rem) !important;\n  box-sizing: border-box !important;\n}.recurrence-form .weekdays-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin: 0.5rem 0;\n}\n\n.recurrence-form .weekdays-row .day {\n  padding: 0.4rem 0.6rem;\n  border-radius: 4px;\n  background: #2e2e2e;\n  color: #ccc;\n  border: 1px solid #444;\n  cursor: pointer;\n}\n\n.recurrence-form .weekdays-row .day.active {\n  background: #2979ff;\n  color: #fff;\n  border-color: #2979ff;\n}\n.mobile-month-header .today-button {\n  font-size: 0.75rem;\n  /* padding: 0.25rem 0.5rem; */\n  /* margin-left: 0.5rem; */\n}\n.mobile-calendar-content .fc tr.fc-scrollgrid-section-header.fc-scrollgrid-section-sticky > th {\n  background: #121212 !important;         /* nền trùng với mobile header */\n  position: sticky !important;\n  /* top = chiều cao .mobile-month-header + .mobile-room-select */\n  top: calc( (3rem) + (2.5rem) ) !important; \n  z-index: 49 !important;\n  height: 3rem !important;                /* bằng row slot height */\n}\n\n/* ─── Center the day labels vertically ─── */\n.mobile-calendar-content .fc .fc-col-header-cell-cushion {\n  display: flex !important;\n  flex-direction: column-reverse !important;\n  align-items: center !important;\n  justify-content: center !important;\n  height: 100% !important;\n}\n.mobile-calendar-container .ui-checkbox__label {\n  color: #ffffff !important;\n}\n\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
